import React from "react";
import { rowColumn, tableOptions } from "../../../components/table/Table";

export enum KindergartenApplicationState {
  pending = "pending",
  submitted = "submitted",
}

export const kindergartenApplicationsListTable = (currPath: string): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "applicationBase.child.firstName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.FirstName",
  },
  {
    label: "Last Name",
    column: "applicationBase.child.lastName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.LastName",
  },
  {
    label: "Kindergarten",
    column: "applicationBase.kindergarten.fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Kindergarten.FundedKinderName",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.applicationBase.kindergarten?.fundedKinderName === "Other"
            ? rowData.applicationBase.kindergarten?.kindergartenNameOther
            : rowData.applicationBase.kindergarten?.fundedKinderName}
        </p>
      );
    },
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.id}`}>View Details</a>,
  },
];

export function kinderTableOptionsBuilder(state: KindergartenApplicationState): tableOptions {
  let searchFilter: string[] = [];
  switch (state) {
    case "pending":
      searchFilter = ["Application - Presubmission"];
      break;
    case "submitted":
      searchFilter = [
        "Application - Add Info first reminder sent",
        "Application - Add Info incomplete",
        "Application - Add Info received",
        "Application - Add Info requested",
        "Application - Add Info second reminder sent",
        "Application - Assessor allocated",
        "Application - Closed - Add Info not received",
        "Application - DE advice requested",
        "Application - Initial review complete",
        "Application - Initial review in progress",
        "Application - On hold",
        "Application - Received / awaiting check",
        "Application - Unable to process",
        "Application - Withdrawn",
        "Assessment - Add Info received",
        "Assessment - Add Info request sent",
        "Assessment - Add Info required",
        "Assessment - Closed - Add Info not received",
        "Assessment - Complete",
        "Assessment - In progress",
        "Assessment - On hold",
        "Assessment - Ready for assessment",
        "Assessment - Withdrawn",
        "QA - Assessor attention required",
        "QA - Commenced",
        "QA - Finalised",
        "QA - Ready for QA",
        "Finalised - Appeal Received",
        "Finalised - Application finalised",
        "Finalised - KIMS entry complete",
        "Finalised - Outcome sent",
      ];
      break;
    default:
      break;
  }

  return {
    sortField: undefined,
    sortOrder: undefined,
    filters: {
      "applicationBase.assignStatus.statusComputed": {
        searchFilter: searchFilter,
      },
    },
  };
}
